import { application } from "./application"
import TurboAppController from "./turbo_app_controller"
import DropdownController from "./dropdown_controller"
import DropdownStatusController from "./dropdown_status_controller"
import DropdownClientController from "./dropdown_client_controller"
import DropdownInvoiceProductController from "./dropdown_invoice_product_controller"
import DropdownInvoicesController from "./dropdown_invoices_controller"
import ModalController from "./modal_controller"
import ExpansionController from "./expansion_controller"
import InvoiceController from "./invoice_controller"
import InvoiceListController from "./invoice_list_controller"
import InvoiceLangController from "./invoice/lang_controller"
import InvoiceSendEmailController from "./invoice_send_email_controller"
import InvoiceContractorsController from "./invoice/contractors_controller"
import InvoiceContractorController from "./invoice/contractor_controller"
import NotificationController from "./notification_controller"
import AccountMainController from "./account/main_controller"
import AccountRequireNative2faController from "./account/require_native2fa_controller"
import MobileTabController from "./mobile_tab_controller"
import MobilePaymentController from "./mobile_payment"
import FormsController from "./forms_controller"
import ProductController from "./product_controller"
import InvoicePositionController from "./invoice/position_controller"
import InvoicePositionCalculatorController from "./invoice/position_calculator_controller"
import InvoicePositionDescriptionController from "./invoice/position_description_controller"
import InvoiceSettlementPositionsController from "./invoice/settlement_positions_controller"
import InvoiceSettlementPositionController from "./invoice/settlement_position_controller"
import InvoiceTaxRateController from "./invoice/tax_rate_controller"
import InvoiceReverseChargeController from "./invoice/reverse_charge_controller"
import InvoiceTriangularTransactionController from "./invoice/triangular_transaction_controller"
import InvoiceVatRrController from "./invoice/vat_rr_controller"
import InvoicePriceOfferController from "./invoice/price_offer_controller"
import InvoiceAccountingNoteController from "./invoice/accounting_note_controller"
import InvoiceMonthFiscalReportController from "./invoice/month_fiscal_report_controller"
import InvoiceLumpSumTaxController from "./invoice/lump_sum_tax_controller"
import FileUploaderController from "./file_uploader_controller"
import DropdownCompanySearchController from "./dropdown_company_search_controller"
import InlineCompanySearchController from "./inline_company_search_controller"
import MoreOptionsController from "./more_options_controller"
import HelplinkController from "./helplink_controller"
import SimpleHideController from "./simple_hide_controller"
import PasswordVisibilityController from "./shared/password_visibility_controller"
import EmailSuggestionController from "./shared/email_suggestion_controller"
import DisclosureController from "./shared/disclosure_controller"
import TabsController from "./tabs_controller"
import ToolbarOverflowController from "./shared/toolbar_overflow_controller"
import AdditionalOptionsController from "./additional_options_controller"
import MultiselectController from "./multiselect_controller"
import CurrencyController from "./currency_controller"
import ThemeController from "./theme_controller"
import ButtonLoaderController from "./button_loader_controller"
import TailwindToggleController from "./tailwind_toggle_controller"
import LangChangeController from "./lang_change_controller"
import ClientController from "./client_controller"
import EstimateModalController from "./estimate_modal_controller"
import RadioAccordionController from "./radio_accordion_controller"
import DepartmentController from "./department_controller"
import MossController from "./moss_controller"
import XsLinkController from "./xs_link_controller"
import ReadMoreController from "./read_more_controller"
import InvoiceTemplatesController from "./invoice_templates_controller"
import DesController from "./des_controller"
import RestrictionModalController from "./restriction_modal_controller"
import ViesController from "./vies_controller"
import WarehouseController from "./warehouse_controller"
import WarehouseDocumentSendController from "./warehouse_document_send_controller"
import WarehouseDocumentPrintController from "./warehouse_document_print_controller"
import DeliveryAddressController from "./delivery_address_controller"
import SummationController from "./summation_controller"
import AccountSettingsController from "./account/settings_controller"
import MaskController from "./mask_controller"
import InvoiceAccountingDatesController from "./invoice_accounting_dates_controller"
import ListMainController from "./list/main_controller"
import ListBulkController from "./list/bulk_controller"
import OcrController from "./ocr_controller"
import DatepickerController from "./datepicker_controller"
import TableController from "./table_controller"
import ScrollHintController from "./scroll_hint_controller"
import LocalStorageController from "./local_storage_controller"
import ProductLimitModalController from "./product_limit_modal_controller"
import AccordionController from "./accordion_controller"
import AccountTwoStepVerificationController from "./account/two_step_verification_controller"
import AccountWebauthnController from "./account/webauthn_controller"
import TwoStepVerificationBackupCodeController from "./two_step_verification/backup_code_controller"
import TwoStepVerificationResendCountdownController from "./two_step_verification/resend_countdown_controller"
import ConfirmUnlockController from "./confirm_unlock_controller"
import ClipboardController from "./shared/clipboard_controller"
import NavigationController from "./shared/navigation_controller"
import ToggleController from "./shared/toggle_controller"
import TooltipController from "./shared/tooltip_controller"
import CounterController from "./shared/counter_controller"
import ScrollSpyController from "./shared/scroll_spy_controller"
import ListSearchController from "./shared/list_search_controller"
import BankAccountDepartmentsController from "./bank_account_departments_controller"
import OfficePricingController from "./office_pricing_controller"
import OfficeSettlementController from "./office_settlement_controller"
import RemoteActionController from "./shared/remote_action_controller"
import ExportModalController from "./export_modal_controller"
import IntumFormController from "./intum_form_controller"
import BannerController from "./banner_controller"
import MarketingConsentController from "./marketing_consent_controller"
import GovModalController from "./gov/modal_controller"
import GovSendModalController from "./gov/send_modal_controller"
import GovKsefExpenseDownloadController from "./gov/ksef_expense_download_controller"
import GovDependentConfirmController from "./gov/dependent_confirm_controller"
import GovIpksefPayConfirmController from "./gov/ipksef_pay_confirm_controller"
import DepartmentBankAccountSelectController from "./department/bank_account_select_controller"
import DropdownBankAccountController from "./dropdown_bank_account_controller"
import DropdownInvoiceBankAccountController from "./dropdown_invoice_bank_accounts_controller"
import DropdownCompanyController from "./dropdown_company_controller"
import InvoiceBulkDeleteController from "./invoice_bulk_delete_controller"
import ApiTokenGuardController from "./api_token_guard_controller"
import BankAccountFormController from "./bank_account/form_controller"
import DepartmentBankAccountsController from "./department/bank_accounts_controller"
import AccountUsersInvitationController from "./account_users/invitation_controller"
import AccountUsersDepartmentsSelectController from "./account_users/departments_select_controller"
import AccountBackupCodesController from "./account/backup_codes_controller"
import InvoiceAddiitionalDescriptionsController from "./invoice/additional_descriptions_controller"
import InvoiceAddiitionalDescriptionController from "./invoice/additional_description_controller"
import InvoiceTransactionTermsController from "./invoice/transaction_terms_controller"
import InvoiceTransactionTermsListController from "./invoice/transaction_terms_list_controller"
import InvoiceTransactionTermsRowController from "./invoice/transaction_terms_row_controller"
import InvoiceTaxController from "./invoice/tax_controller"
import SubmitLockController from "./shared/submit_lock_controller"
import FlexTableController from "./shared/flex_table_controller"
import PlanSelectController from "./plan_select_controller"
import InvoiceInlineEstimateController from "./invoice/inline_estimate_controller"
import InvoiceFacturaeAdminCenterController from "./invoice/facturae_admin_center_controller"
import InvoiceJstGvController from "./invoice/jst_gv_controller"
import InvoiceClientDataConfirmController from "./invoice/client_data_confirm_controller"
import AccountingOfficeCompletenessReminderTriggerController from "./accounting_office/completeness_reminder_trigger_controller"
import AccountingOfficeDocumentCompletenessController from "./accounting_office/document_completeness_controller"
import ChartController from "./chart_controller"
import WhitelabelBulkSettleController from "./whitelabel/bulk_settle_controller"
import WhitelabelReportFormController from "./whitelabel/report_form_controller"

application.register("turbo-app", TurboAppController)
application.register("dropdown", DropdownController)
application.register("dropdown-status", DropdownStatusController)
application.register("dropdown-client", DropdownClientController)
application.register("dropdown-invoice-product", DropdownInvoiceProductController)
application.register("dropdown-invoices", DropdownInvoicesController)
application.register("modal", ModalController)
application.register("expansion", ExpansionController)
application.register("invoice", InvoiceController)
application.register("invoice-list", InvoiceListController)
application.register("invoice--lang", InvoiceLangController)
application.register("invoice-send-email", InvoiceSendEmailController)
application.register("invoice--contractors", InvoiceContractorsController)
application.register("invoice--contractor", InvoiceContractorController)
application.register('notification', NotificationController)
application.register("account--main", AccountMainController)
application.register("account--require-native2fa", AccountRequireNative2faController)
application.register('mobile-tab', MobileTabController)
application.register("mobile-payment", MobilePaymentController)
application.register('forms', FormsController)
application.register('invoice--position', InvoicePositionController)
application.register('invoice--position-calculator', InvoicePositionCalculatorController)
application.register('invoice--position-description', InvoicePositionDescriptionController)
application.register('invoice--settlement-positions', InvoiceSettlementPositionsController)
application.register('invoice--settlement-position', InvoiceSettlementPositionController)
application.register('invoice--tax-rate', InvoiceTaxRateController)
application.register('invoice--reverse-charge', InvoiceReverseChargeController)
application.register('invoice--triangular-transaction', InvoiceTriangularTransactionController)
application.register('invoice--vat-rr', InvoiceVatRrController)
application.register('invoice--price-offer', InvoicePriceOfferController)
application.register('invoice--accounting-note', InvoiceAccountingNoteController)
application.register('invoice--month-fiscal-report', InvoiceMonthFiscalReportController)
application.register('invoice--lump-sum-tax', InvoiceLumpSumTaxController)
application.register('file-uploader', FileUploaderController)
application.register("dropdown-company-search", DropdownCompanySearchController)
application.register("inline-company-search", InlineCompanySearchController)
application.register("more-options", MoreOptionsController)
application.register('product', ProductController)
application.register("helplink", HelplinkController)
application.register("simple-hide", SimpleHideController)
application.register("password-visibility", PasswordVisibilityController)
application.register("email-suggestion", EmailSuggestionController)
application.register("disclosure", DisclosureController)
application.register("tabs", TabsController)
application.register("toolbar-overflow", ToolbarOverflowController)
application.register("additional-options", AdditionalOptionsController)
application.register("multiselect", MultiselectController)
application.register("currency", CurrencyController)
application.register("theme", ThemeController)
application.register("button-loader", ButtonLoaderController)
application.register("tailwind-toggle", TailwindToggleController)
application.register("lang-change", LangChangeController)
application.register("client", ClientController)
application.register("estimate-modal", EstimateModalController)
application.register("radio-accordion", RadioAccordionController)
application.register("department", DepartmentController)
application.register("moss", MossController)
application.register("xs-link", XsLinkController)
application.register("read-more", ReadMoreController)
application.register("invoice-templates", InvoiceTemplatesController)
application.register("des", DesController)
application.register("restriction-modal", RestrictionModalController)
application.register("vies", ViesController)
application.register("warehouse", WarehouseController)
application.register("warehouse-document-send", WarehouseDocumentSendController)
application.register("warehouse-document-print", WarehouseDocumentPrintController)
application.register("delivery-address", DeliveryAddressController)
application.register("summation", SummationController)
application.register("account--settings", AccountSettingsController)
application.register("mask", MaskController)
application.register("invoice-accounting-dates", InvoiceAccountingDatesController)
application.register("list--main", ListMainController)
application.register("list--bulk", ListBulkController)
application.register("ocr", OcrController)
application.register("datepicker", DatepickerController)
application.register("table", TableController)
application.register("scroll-hint", ScrollHintController)
application.register("local-storage", LocalStorageController)
application.register("product-limit-modal", ProductLimitModalController)
application.register("accordion", AccordionController)
application.register("account--two-step-verification", AccountTwoStepVerificationController)
application.register("account--webauthn", AccountWebauthnController)
application.register("two-step-verification--backup-code", TwoStepVerificationBackupCodeController)
application.register("two-step-verification--resend-countdown", TwoStepVerificationResendCountdownController)
application.register("clipboard", ClipboardController)
application.register("confirm-unlock", ConfirmUnlockController)
application.register("navigation", NavigationController)
application.register("toggle", ToggleController)
application.register("tooltip", TooltipController)
application.register("counter", CounterController)
application.register("scroll-spy", ScrollSpyController)
application.register("list-search", ListSearchController)
application.register("bank-account-departments", BankAccountDepartmentsController)
application.register("office-pricing", OfficePricingController)
application.register("office-settlement", OfficeSettlementController)
application.register("remote-action", RemoteActionController)
application.register("export-modal", ExportModalController)
application.register("intum-form", IntumFormController)
application.register("banner", BannerController)
application.register("marketing-consent", MarketingConsentController)
application.register("gov--modal", GovModalController)
application.register("gov--send-modal", GovSendModalController)
application.register("gov--ksef-expense-download", GovKsefExpenseDownloadController)
application.register("gov--dependent-confirm", GovDependentConfirmController)
application.register("gov--ipksef-pay-confirm", GovIpksefPayConfirmController)
application.register("department--bank-account-select", DepartmentBankAccountSelectController)
application.register("dropdown-bank-account", DropdownBankAccountController)
application.register("dropdown-invoice-bank-account", DropdownInvoiceBankAccountController)
application.register("dropdown-company", DropdownCompanyController)
application.register("invoice-bulk-delete", InvoiceBulkDeleteController)
application.register("api-token-guard", ApiTokenGuardController)
application.register("bank-account--form", BankAccountFormController)
application.register("account-users--invitation", AccountUsersInvitationController)
application.register("account-users--departments-select", AccountUsersDepartmentsSelectController)
application.register("department--bank-accounts", DepartmentBankAccountsController)
application.register("account--backup-codes", AccountBackupCodesController)
application.register("invoice--additional-descriptions", InvoiceAddiitionalDescriptionsController)
application.register("invoice--additional-description", InvoiceAddiitionalDescriptionController)
application.register("invoice--transaction-terms", InvoiceTransactionTermsController)
application.register("invoice--transaction-terms-list", InvoiceTransactionTermsListController)
application.register("invoice--transaction-terms-row", InvoiceTransactionTermsRowController)
application.register("invoice--facturae-admin-center", InvoiceFacturaeAdminCenterController)
application.register("invoice--tax", InvoiceTaxController)
application.register("submit-lock", SubmitLockController)
application.register("flex-table", FlexTableController)
application.register("plan-select", PlanSelectController)
application.register("invoice--inline-estimate", InvoiceInlineEstimateController)
application.register("invoice--jst-gv", InvoiceJstGvController)
application.register("invoice--client-data-confirm", InvoiceClientDataConfirmController)
application.register("accounting-office--completeness-reminder-trigger", AccountingOfficeCompletenessReminderTriggerController)
application.register("accounting-office--document-completeness", AccountingOfficeDocumentCompletenessController)
application.register("chart", ChartController)
application.register("whitelabel--bulk-settle", WhitelabelBulkSettleController)
application.register("whitelabel--report-form", WhitelabelReportFormController)
